<template>
  <div style="width: 100%;">
    <el-select v-model="currentSelectId" :disabled="disabled" style="width: 100%;" :placeholder="placeholder" :multiple="multiple" :collapse-tags="collapseTags" clearable @change="selectChange">
      <el-option v-for="item in currentColumns" :key="item.value" :label="item.text" :value="item.value" />
    </el-select>
  </div>
</template>

<script>

export default {
  name: 'WqSelect',
  props: {
    selected: {
      type: [String, Number, Array],
      required: true,
      default: 0
    },
    columns: {
      type: Array,
      default() {
        return []
      }
    },
    dataFunc: {
      type: Function,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: [Boolean, String],
      default: false
    },
    valueName: {
      type: String,
      default: ''
    },
    textName: {
      type: String,
      default: ''
    },
    useIndex: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentSelectId: '',
      currentColumns: []
    }
  },
  watch: {
    columns(newVal, oldVal) {
      if (newVal !== null) {
        this.currentColumns = newVal
        this.convertData()
      }
    },
    selected(newVal, oldVal) {
      if (newVal !== null) {
        this.currentSelectId = newVal
      }
    }

  },
  created() {},
  async mounted() {
    this.currentSelectId = this.selected
    this.currentColumns = this.columns
    if (this.dataFunc) {
      const res = await this.dataFunc()
      this.currentColumns = res.data
    }
    this.convertData()
  },
  methods: {
    convertData() {
      this.currentColumns = this.currentColumns.map((item, index) => {
        const obj = Object.assign({}, item)
        if (this.textName) { obj.text = obj[this.textName] }
        if (this.valueName) { obj.value = obj[this.valueName] }
        if (this.useIndex) { obj.value = index } // 使用index用索引值把value覆盖
        return obj
      })
    },
    selectChange(e) {
      this.$emit('update:selected', e)
      this.$emit('change', { e, name: this.name })
    }
  }
}
</script>

  <style></style>
